import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllCurriculos } from '../api';
import CurriculoModal from '../components/CurriculoModal';

export default function AdminScreen() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('authToken');
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState<any | null>(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (!token) {
      navigate('/acesso-profissional');
      return;
    }
    loadData();
  }, [token, navigate]);

  const loadData = async () => {
    setLoading(true);
    try {
      const list = await getAllCurriculos();
      setItems(list.items || []);
    } catch (e: any) {
      setError('Erro ao carregar currículos');
      if (e?.response?.status === 401) {
        sessionStorage.removeItem('authToken');
        navigate('/acesso-profissional');
      }
    } finally {
      setLoading(false);
    }
  };

  // Filtra currículos por nome ou CPF (case-insensitive)
  const filteredItems = items.filter(it => {
    const nome = (it.data?.dadosPessoais?.nome || '').toLowerCase();
    const cpf = (it.cpf || '').toLowerCase();
    const search = searchTerm.toLowerCase();
    return nome.includes(search) || cpf.includes(search);
  });

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', paddingTop: 32 }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
            <h3 style={{ margin: 0, color: 'var(--primary-color)' }}>Currículos Salvos ({items.length})</h3>
            <div style={{ display: 'flex', gap: '12px' }}>
                <button className="btn btn-primary" onClick={() => navigate('/acesso-profissional')} style={{ padding: '8px 16px', fontSize: 13 }}>
                  Voltar
                </button>
            </div>
          </div>

          {loading && <p style={{ color: 'var(--text-light)', textAlign: 'center' }}>Carregando dados...</p>}
          {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
          
          <div className="form-group" style={{ maxWidth: 420, marginBottom: 16 }}>
            <label>Buscar por nome ou CPF</label>
            <input
              type="text"
              placeholder="Digite o nome ou CPF..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Mensagem se houver filtro ativo */}
          {searchTerm && (
            <p style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
              Mostrando {filteredItems.length} de {items.length} currículo(s)
            </p>
          )}

          {/* Tabela com currículos filtrados */}
          {filteredItems.length > 0 ? (
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 12 }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>CPF</th>
                  <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>Nome</th>
                  <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: 8 }}>Atualizado</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((it) => (
                  <tr key={it.cpf} style={{ cursor: 'pointer' }} onClick={() => setSelected(it)}>
                    <td style={{ padding: 8, borderBottom: '1px solid #f0f0f0' }}>{it.cpf}</td>
                    <td style={{ padding: 8, borderBottom: '1px solid #f0f0f0' }}>{it.data?.dadosPessoais?.nome || '—'}</td>
                    <td style={{ padding: 8, borderBottom: '1px solid #f0f0f0' }}>{it.updated_at || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#999', marginTop: 12 }}>
              {searchTerm ? 'Nenhum currículo encontrado com esse filtro.' : 'Nenhum currículo salvo.'}
            </p>
          )}

          <div style={{ marginTop: 16 }}>
            <button className="btn btn-secondary" onClick={() => navigate('/acesso-profissional')}>
              Voltar
            </button>
          </div>

      {selected && <CurriculoModal item={selected} onClose={() => setSelected(null)} />}
    </div>
  </div>
  );
}
